import {
  attr,
  customElement,
  FASTElement,
  Observable,
  observable,
  Splice,
} from '@microsoft/fast-element';
import {
  MyPortfolioTemplate as template,
} from './my-portfolio.template';
import { MyPortfolioStyles as styles } from './my-portfolio.styles';
import { AllRfq } from '../all-rfq/all-rfq';
import { VPPA_RFQ_STATUS, NEGOTIATION_STATUS } from '../../../../utils';
import { Tabs } from '@microsoft/fast-foundation';
import { COLUMN_FIELDS } from '../all-rfq/column-config';
import { COLUMN_FIELDS as NEGOTIATION_COLUMN_FIELDS } from '../../../common/negotiations-grid/column-config';
import { NegotiationsGrid, SHARED_DASHBOARD_GRID_TABS } from '../../../common/negotiations-grid/negotiations-grid';
import { ICompanyService } from '../../../../services/company.service';
import { hasLegalOrAuthorizedSignatoryVisibility } from '../../../../utils/profiles';
import {
  convertDateToUTC,
  getCreditProfileValue,
  getFormattedDate,
  getPriceValue,
} from '../../../../utils/formatting';
import { getGroupColumnSameObject } from '../../../../utils/grid';
import { INotificationService } from '../../../../services/notification.service';
import { IUserService } from '../../../../services/user.service';

const name = 'my-portfolio';

@customElement({
  name,
  template,
  styles,
})
export class MyPortfolio extends FASTElement {
  @ICompanyService companyService: ICompanyService;
  @INotificationService notificationService: INotificationService;
  @observable allRfq: AllRfq;
  @observable rfqGridTabs: Tabs;
  @observable isNegotiationTabSelected: boolean = false;
  @observable negotiationGrid: NegotiationsGrid;
  @observable companyId: string;
  @IUserService userService: IUserService;
  @attr @observable activeTabId: string;

  private notifier: any;
  private handler: any;

  connectedCallback() {
    super.connectedCallback();

    if (this.showOnlyNegotiations()) {
      this.rfqGridTabs.activeid = SHARED_DASHBOARD_GRID_TABS.NEGOTIATIONS_TAB;
      this.isNegotiationTabSelected = true;
    }

    const valueFromNotification = this.notificationService.getDashboardTab();
    if (valueFromNotification) {
      setTimeout(() => {
        this.rfqGridTabs.activeid = valueFromNotification;
        if (valueFromNotification === SHARED_DASHBOARD_GRID_TABS.TERMINATED_TAB) {
          this.allTerminatedNegotiations();
          this.notificationService.clearDashboardTab();
        }
      }, 500);
    }

    this.createNotificationNotifier();
  }

  private createNotificationNotifier() {
    const context = this;
    this.notifier = Observable.getNotifier(this.notificationService);
    this.handler = {
      handleChange(source: any, splices: Splice[]) {
        const valueFromNotification = context.notificationService.getDashboardTab();
        if (valueFromNotification) {
          context.rfqGridTabs.activeid = valueFromNotification;
          if (valueFromNotification === SHARED_DASHBOARD_GRID_TABS.TERMINATED_TAB) {
            context.allTerminatedNegotiations();
            //context.notificationService.clearDashboardTab();
          }
        }
      },
    };
    this.notifier.subscribe(this.handler, 'dashboardTab');
  }

  disconnectedCallback() {
    this.notifier.unsubscribe(this.handler);
    super.disconnectedCallback();
  }

  public allRfqsTradingActivity() {
    this.isNegotiationTabSelected = false;
    this.allRfq.rfqVppaCriteria = {
      rfqCriteria: `NEGOTIATION_ID != null && (RFQ_STATUS == '${VPPA_RFQ_STATUS.ACTIVE}' || RFQ_STATUS == '${VPPA_RFQ_STATUS.TRADE_PENDING}' ||  RFQ_STATUS == '${VPPA_RFQ_STATUS.EXISTING_INTEREST}') && NEGOTIATION_STATUS != '${NEGOTIATION_STATUS.REJECTED}'`,
      vppaNegotiationCriteria: `BUYER_VISIBILITY == true && (VPPA_STATUS == '${VPPA_RFQ_STATUS.ACTIVE}' || VPPA_STATUS == '${VPPA_RFQ_STATUS.TRADE_PENDING}' || VPPA_STATUS == '${VPPA_RFQ_STATUS.EXISTING_INTEREST}') &&
        (NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.IN_PROGRESS}' || NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.REQUIRES_CONFIRMATION}' || NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.CONFIRMED_AWAITING_BUYER}' || NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.CONFIRMED_AWAITING_SELLER}' || NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.SUCCESSFUL}') && NEGOTIATION_STATUS != '${NEGOTIATION_STATUS.REJECTED}'
      `,
    };
    this.allRfq.setColumnVisibility(COLUMN_FIELDS.CONTRACT_TYPE, false);
    this.allRfq.setColumnVisibility(COLUMN_FIELDS.PROJECT, true);
  }

  public allActiveRfqs() {
    this.isNegotiationTabSelected = false;
    this.allRfq.rfqVppaCriteria = {
      rfqCriteria: `(RFQ_STATUS == '${VPPA_RFQ_STATUS.ACTIVE}' || RFQ_STATUS == '${VPPA_RFQ_STATUS.TRADE_PENDING}' ||  RFQ_STATUS == '${VPPA_RFQ_STATUS.EXISTING_INTEREST}' && NEGOTIATION_STATUS != '${NEGOTIATION_STATUS.REJECTED}' )`,
      vppaNegotiationCriteria: `BUYER_VISIBILITY == true && (VPPA_STATUS == '${VPPA_RFQ_STATUS.ACTIVE}' || VPPA_STATUS == '${VPPA_RFQ_STATUS.TRADE_PENDING}' || VPPA_STATUS == '${VPPA_RFQ_STATUS.EXISTING_INTEREST}') &&
        (NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.IN_PROGRESS}' || NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.REQUIRES_CONFIRMATION}' || NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.CONFIRMED_AWAITING_BUYER}' || NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.CONFIRMED_AWAITING_SELLER}' || NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.SUCCESSFUL}') && NEGOTIATION_STATUS != '${NEGOTIATION_STATUS.REJECTED}'
      `,
    };
    this.allRfq.setColumnVisibility(COLUMN_FIELDS.PROJECT, false);
    this.allRfq.setColumnVisibility(COLUMN_FIELDS.CONTRACT_TYPE, true);
  }

  public allInactiveRfqs() {
    this.isNegotiationTabSelected = false;
    this.allRfq.rfqVppaCriteria = {
      rfqCriteria: `(RFQ_STATUS == '${VPPA_RFQ_STATUS.DELETED}' || RFQ_STATUS == '${VPPA_RFQ_STATUS.DELISTED}' ||  RFQ_STATUS == '${VPPA_RFQ_STATUS.INSUFFICIENT_DATA}' )`,
      vppaNegotiationCriteria: `BUYER_VISIBILITY == true`,
    };
    this.allRfq.setColumnVisibility(COLUMN_FIELDS.PROJECT, false);
    this.allRfq.setColumnVisibility(COLUMN_FIELDS.CONTRACT_TYPE, true);
  }

  public allExecutedNegotiations() {
    this.isNegotiationTabSelected = true;
    this.negotiationGrid.matchCriteria = `NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.EXECUTED}'`;
    this.negotiationGrid.negotiationsGrid.columnApi.setColumnVisible(
      NEGOTIATION_COLUMN_FIELDS.SELLER_COMPANY_NAME,
      true,
    );
    this.negotiationGrid.negotiationsGrid.columnApi.setColumnVisible(
      NEGOTIATION_COLUMN_FIELDS.BUYER_COMPANY_NAME,
      false,
    );
    this.negotiationGrid.negotiationsGrid.columnApi.setColumnVisible(
      NEGOTIATION_COLUMN_FIELDS.EXECUTED_DATE_TIME,
      true,
    );
  }

  public allTerminatedNegotiations() {
    this.isNegotiationTabSelected = true;
    this.negotiationGrid.matchCriteria = `(NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.REJECTED}' || NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.TRADED_AWAY}')`;
    this.negotiationGrid.negotiationsGrid.columnApi.setColumnVisible(
      NEGOTIATION_COLUMN_FIELDS.SELLER_COMPANY_NAME,
      true,
    );
    this.negotiationGrid.negotiationsGrid.columnApi.setColumnVisible(
      NEGOTIATION_COLUMN_FIELDS.BUYER_COMPANY_NAME,
      false,
    );
    this.negotiationGrid.negotiationsGrid.columnApi.setColumnVisible(
      NEGOTIATION_COLUMN_FIELDS.EXECUTED_DATE_TIME,
      false,
    );
  }

  public allNegotiations() {
    this.getCompanyId();
    this.isNegotiationTabSelected = true;
    this.negotiationGrid.matchCriteria =
      `(NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.IN_PROGRESS_ARTERIA}' ` +
      `|| NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.PENDING_EXECUTION}' ` +
      `|| NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.PENDING_EXECUTION_TIMER}' ` +
      `|| NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.READY_FOR_TRADE_EXECUTION}' ` +
      `|| NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.REVIEW_EXECUTION_CHECKLIST}' ` +
      `|| NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.EXECUTED_AWAITING_BUYER}' ` +
      `|| NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.EXECUTED_AWAITING_SELLER}' ` +
      `|| NEGOTIATION_STATUS == '${NEGOTIATION_STATUS.EXPIRED}')`;
    this.negotiationGrid.negotiationsGrid.columnApi.setColumnVisible(
      NEGOTIATION_COLUMN_FIELDS.SELLER_COMPANY_NAME,
      true,
    );
    this.negotiationGrid.negotiationsGrid.columnApi.setColumnVisible(
      NEGOTIATION_COLUMN_FIELDS.BUYER_COMPANY_NAME,
      false,
    );
    this.negotiationGrid.negotiationsGrid.columnApi.setColumnVisible(
      NEGOTIATION_COLUMN_FIELDS.EXECUTED_DATE_TIME,
      false,
    );
  }

  private getCompanyId() {
    this.companyId = this.companyId
      ? this.companyId
      : this.companyService.getCurrentCompany().CASCADE_COMPANY_ID;
  }

  public openRfqModal() {
    this.$emit('openRfqModal');
  }

  public showOnlyNegotiations(): boolean {
    return hasLegalOrAuthorizedSignatoryVisibility(this.userService.getFilteredPermissions());
  }

  public downloadGridCsv() {
    if (this.isNegotiationTabSelected) {
      const csvParams = {
        fileName: this.rfqGridTabs.activeid,
        processCellCallback: (params) => {
          let formattedValue = params.value;
          if (params.column.getColId() === NEGOTIATION_COLUMN_FIELDS.FIXED_PRICE) {
            formattedValue = getPriceValue(params.value, '', '$');
          } else if (params.column.getColId() === COLUMN_FIELDS.TENOR_START_DATE) {
            formattedValue = getFormattedDate(params.value);
          } else if (
            params.column.getColId() === NEGOTIATION_COLUMN_FIELDS.SELLER_SETTLEMENT_POINT
          ) {
            formattedValue = params.value
              ? params.node.data.SETTLEMENT_POINT
              : getGroupColumnSameObject(params, NEGOTIATION_COLUMN_FIELDS.RFQ_DETAILS)
                  .VPPA_SETTLEMENT_POINT;
          } else if (params.column.getColId() === NEGOTIATION_COLUMN_FIELDS.EXECUTED_DATE_TIME) {
            formattedValue = convertDateToUTC(new Date(params.value)).toLocaleString();
          } else if (
            params.column.getColId() === NEGOTIATION_COLUMN_FIELDS.BUYER_POST_COD_COLLATERAL
          ) {
            let groupedCreditProfile = getGroupColumnSameObject(
              params,
              NEGOTIATION_COLUMN_FIELDS.RFQ_DETAILS,
            ).RFQ_CREDIT_PROFILE;

            formattedValue = getCreditProfileValue(groupedCreditProfile, params.value);
          } else if (
            params.column.getColId() === NEGOTIATION_COLUMN_FIELDS.SELLER_POST_COD_COLLATERAL
          ) {
            let groupedCreditProfile = getGroupColumnSameObject(
              params,
              NEGOTIATION_COLUMN_FIELDS.VPPA_DETAILS,
            ).VPPA_CREDIT_PROFILE;
            formattedValue = getCreditProfileValue(groupedCreditProfile, params.value);
          }
          return formattedValue;
        },
      };
      this.negotiationGrid.negotiationsGrid.gridApi.exportDataAsCsv(csvParams);
    } else {
      this.allRfq.downloadGridCsv();
    }
  }
}
